import React from 'react';
import axios from 'axios';
import { Toaster, toast } from 'react-hot-toast';
// import { Link } from 'react-router-dom';
// import ProfileFeed from './profile/ProfileFeed';
import InfiniteScroll from 'react-infinite-scroll-component';
import ShakaPlayerComponent from './ShakaPlayerComponent';
import ProfilePic from '../ProfilePicTemp.png';
import { Dialog, Transition, TransitionChild, DialogPanel, DialogTitle } from '@headlessui/react';
import MoonLoader from 'react-spinners/MoonLoader';
// import Cards from 'react-credit-cards-2';
// import "react-credit-cards-2/dist/es/styles-compiled.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
// import { CreditCard, PaymentForm, CashAppPay, GooglePay } from 'react-square-web-payments-sdk';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
// import clerk from '../utils/clerk';
import { getToken, forceLogout } from '../hooks/AuthProvider';
import FeedComponent from './FeedComponent';

type props = {};

type state = {
    loading: boolean;
    subscriptions: any[];
    user: any[];
    username: string;
    following: boolean;
    isSelf: boolean;
    items: any[];
    pageNum: number;
    hasMore: boolean;
    loadingMore: boolean;
    followingUser: boolean;
    bannerURL: string;
    verified: boolean;
    profileModalShown: boolean;
    profileUploading: boolean;
    purchaseShow: boolean;
    purchaseData: post | null;
    isPaymentActive: boolean;
    myName: string;
    purchaseID: string;
    email: string;
    comments: any[];
    commentModal: boolean;
    commentVal: string;
    authorizationToken: string | null;
}

type post = {
    access: boolean;
    createdAt: string;
    description: string;
    followers: number;
    isPostLiked: boolean;
    likes: number;
    postID: string;
    price: number;
    profilePic: {
        profilePic: string;
        _id: string;
    };
    status: string;
    title: string;
    username: string;
}

export default class UserComponent extends React.PureComponent<props, state> {
    private usernameInput = React.createRef<HTMLInputElement>();
    private displayNameInput = React.createRef<HTMLInputElement>();
    private closeModalBTN = React.createRef<HTMLButtonElement>();
    private payBTN = React.createRef<HTMLButtonElement>();
    
    constructor(props: any) {
        super(props);
        this.state = {
            loading: true,
            subscriptions: [],
            user: [],
            username: '',
            following: false,
            isSelf: false,
            items: [],
            pageNum: 0,
            hasMore: true,
            loadingMore: false,
            followingUser: false,
            verified: false,
            bannerURL: '',
            profileModalShown: false,
            profileUploading: false,
            purchaseShow: false,
            purchaseData: null,
            isPaymentActive: false,
            purchaseID: '',
            myName: '',
            email: '',
            comments: [],
            commentModal: false,
            commentVal: '',
            authorizationToken: null,
        }
        // this.toggleFollow = this.toggleFollow.bind(this);
        this.fetchData = this.fetchData.bind(this);
        // this.inputChange = this.inputChange.bind(this);
        this.closeCommentModal = this.closeCommentModal.bind(this);
        this.openCommentModal = this.openCommentModal.bind(this);
        this.postComment = this.postComment.bind(this);
        // this.checkoutSession = this.checkoutSession.bind(this);
        // this.loadStripeComponent = this.loadStripeComponent.bind(this);
    }

    componentDidMount(): void {
        // var username = window.location.pathname.split('/')[2];
        var displayNamePrompt = window.location.search;
        console.log(displayNamePrompt)

        // console.log(displayNamePrompt.split('=')[1]);

        if (displayNamePrompt.split('=')[1] === 'true') {
            // Prompt user to enter display name
            this.setState({profileModalShown: true});
        }

        const script = document.createElement('script');
        script.src = '/jsencrypt.min.js';
        script.async = true;
        document.body.appendChild(script);

        // this.setState({username: username});
        // var token = localStorage.getItem('token');
        // if (clerk.user) {
            // Axios request to backend ...

            // clerk.session?.getToken().then(async (token) => {
                axios.get(`${process.env.REACT_APP_API_URL}api/v1/myPurchased`, { headers: { 'x-auth-token': getToken() } }).then((res) => {
                    if (res.data.user === null) {
                        // Redirect to 404
                        window.location.href = '/404';
                    } else {
                        this.setState({ items: res.data.posts, pageNum: 1, myName: res.data.displayName, user: res.data.user, username: res.data.user._id, loading: false, following: res.data.following, isSelf: res.data.isSelf, bannerURL: res.data.bannerPic, authorizationToken: res.data.authorizationToken || null });
                    }
                }).catch(err => {
                    // const data = err.response.data;
                    this.setState({ items: err.response.data.posts, pageNum: 1, myName: err.response.data.displayName, user: err.response.data.user, username: err.response.data.user._id, loading: false, following: err.response.data.following, isSelf: err.response.data.isSelf, bannerURL: err.response.data.bannerPic, authorizationToken: err.response.data.authorizationToken || null });
                    console.error(err.response.data)
                });

            // axios.get(`${process.env.REACT_APP_API_URL}api/v1/user/${username}`, { headers: { 'x-auth-token': token } }).then((res: any) => {
            //     // console.log(res.data.user);
            //     if (res.data.user === null) {
            //         // Redirect to 404
            //         window.location.href = '/404';
            //     } else {
            //         this.setState({ myName: res.data.self.displayName, user: res.data.user, username: username, loading: false, following: res.data.following, isSelf: res.data.isUser, bannerURL: res.data.bannerPic });
            //     }
            // }).catch(err => {
            //     if (err.response.data.msg === 'Not Verified') {
            //         // Redirect to login
            //         localStorage.removeItem('token');
            //         window.location.href = '/login';
            //     } else if (err.response.data.msg === 'User not found') {
            //         window.location.href = '/404';
            //     }
            //     console.error(err);
            // });

            // axios.get(`${process.env.REACT_APP_API_URL}api/v1/user/${username}/feed`, { headers: { 'x-auth-token': token} }).then((res) => {
            //     console.log(res.data);
            //     this.setState({ items: res.data.posts, pageNum: 1, followingUser: true });
            // }).catch((err) => {
            //     console.log(err);
            //     if (err.response.data.msg === 'User not following') {
            //         this.setState({followingUser: false})
            //     } else if (err.response.data.msg === 'No posts found') {
            //         this.setState({ hasMore: false, followingUser: true });
            //     } else if (err.response.data.msg === 'Not Verified') {
            //         localStorage.removeItem('token');
            //         window.location.href = '/login';
            //     } else if (err.response.data.error === 'Missing Auth Token') {
            //         localStorage.removeItem('token');
            //         window.location.href = '/login';
            //     }
            // });

                axios.post(`${process.env.REACT_APP_API_URL}api/v1/user/email`, null, { headers: { 'x-auth-token': getToken() } }).then((res) => {
                    this.setState({ email: res.data.email });
                }).catch(err => {
                    console.log(err);
                })
            // });
        // } else {
        //     // Redirect to login
        //     window.location.href = '/login';
        // }
    }

    async fetchData() {
        if (!this.state.hasMore || this.state.loadingMore) return;

        const nextPage = this.state.pageNum + 1;
        this.setState({ loadingMore: true });

        axios.get(`${process.env.REACT_APP_API_URL}api/v1/myPurchased?page=${nextPage}`, { headers: { 'x-auth-token': getToken() } }).then((res) => {
            if (res.data.posts && res.data.posts.length > 0) {
                this.setState(prevState => ({
                    items: [...prevState.items, ...res.data.posts],
                    pageNum: nextPage,
                    loadingMore: false,
                    followingUser: true,
                    verified: res.data.verified,
                    authorizationToken: res.data.authorizationToken || prevState.authorizationToken,
                }));
            } else {
                this.setState({ hasMore: false, loadingMore: false });
            }
        }).catch((err) => {
            console.log(err);
            this.setState({ loadingMore: false });
            if (err.response?.data?.msg === 'User not following') {
                this.setState({ followingUser: false });
            } else if (err.response?.data?.msg === 'No Purchases Found') {
                this.setState({ hasMore: false });
            } else if (err.response?.data?.msg === 'Not Verified' || err.response?.data?.error === 'Missing Auth Token') {
                forceLogout();
            }
        });
    }

    async toggleLike(e: any, postID: any) {
        // e.target.classList.toggle('text-red-500');
        // e.target.classList.toggle('fa-heart');

        // Make API request 
        // var token = localStorage.getItem('token');
        axios.put(`${process.env.REACT_APP_API_URL}api/v1/post/${postID}/like`, null, { headers: { 'x-auth-token': getToken() } }).then((res) => {
            // Update selected `post` in state to avoid updating all posts ...
            // this.setState({})
            var updatedItems = this.state.items.map((post) => {
                if (post.postID === postID) {
                    post.likes = res.data.likes;
                    post.isPostLiked = !post.isPostLiked;
                }
                return post;
            });
            this.setState({ items: updatedItems });
        }).catch((err) => {
            console.error(err);
            if (err.response.data.msg === 'Not Verified' || err.response.data.error === 'Missing Auth Token') {
                forceLogout();
            } else {
                // e.target.classList.toggle('text-red-500');
                // e.target.classList.toggle('fa-heart');
                // Toast like error to user
                toast.error('An error has occurred!', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
            }
        });

    }

    responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
    };

    async uploadBanner() {
        var fileInput = document.getElementById('profileBanner');
        if (fileInput) {
            fileInput.click();
            fileInput.addEventListener('change', async (e: any) => {
                // console.log(e.target.files[0]);
                var file = e.target.files[0];
                var formData = new FormData();
                formData.append('file', file);
                axios.post(`${process.env.REACT_APP_API_URL}api/v1/user/banner`, formData, { headers: { 'x-auth-token': getToken() } }).then((res) => {
                    // console.log(res.data);
                    if (res.data.msg === 'Banner Updated') {
                        // this.setState({ user: res.data.user });
                        window.location.reload();
                    } else {
                        toast.error('An error has occurred!', { style: {
                            color: '#ffffff',
                            backgroundColor: '#242C37',
                        }});
                    }
                }).catch(err => {
                    console.error(err);
                });
            });
        }
    }

    async uploadProfilePic() {
        var fileInput = document.getElementById('profilePicture');
        console.log(fileInput)
        if (fileInput) {
            fileInput.click();
            fileInput.addEventListener('change', async (e: any) => {
                // console.log(e.target.files[0]);
                var file = e.target.files[0];
                var formData = new FormData();
                formData.append('file', file);

                axios.post(`${process.env.REACT_APP_API_URL}api/v1/user/profilepic`, formData, { headers: { 'x-auth-token': getToken() } }).then((res) => {
                    // console.log(res.data);
                    // this.setState({ user: res.data.user });
                    window.location.reload();
                }).catch(err => {
                    console.error(err);
                });
            });
        }
    }

    closeProfileModal() {
        this.setState({ profileModalShown: false });
    }

    openEditModal() {
        this.setState({ profileModalShown: true });
    }

    async updateProfile() {
        // var token = localStorage.getItem('token');
        var displayName = this.displayNameInput.current?.value;
        var username = this.usernameInput.current?.value;
        await axios.post(`${process.env.REACT_APP_API_URL}api/v1/user/profile`, { displayName: displayName }, { headers: { 'x-auth-token': getToken() } }).then((res) => {
            // console.log(res.data);
            this.setState({ user: res.data.user });
            this.closeProfileModal();
            toast.success('Profile Updated!', { style: {
                color: '#ffffff',
                backgroundColor: '#242C37',
            }});
            setTimeout(() => {
                // @ts-ignore
                if (this.state.verified === true) {
                    // @ts-ignore
                    if (this.state.user.username !== username) {
                        // Got to new Profile
                        window.location.href = `/app/user/${username}`;
                    } else {
                        window.location.reload();
                    }
                } else {
                    window.location.href = `/app/profile`
                    // window.location.reload();
                }
            }, 200);
        }).catch(err => {
            console.error(err);
            if (err.response.data.msg === 'Not Verified') {
                forceLogout();
            } else if (err.response.data.msg === 'Display Name or Username already exists') {
                toast.error('Display Name already exists!', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
            } else {
                toast.error('An error has occurred!', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
            }
        });
    }

    closeCommentModal() {
        this.setState({ commentModal: false });
    }

    openCommentModal(comments: any[]) {
        this.setState({ commentModal: true, comments: comments });
    }
    
    postComment(e: any) {
        e.preventDefault();
        // Get comment value
        var comment = this.state.commentVal;

        console.log(comment);

        var newComment = {
            comment: comment
        }
    }

    render() {
        function formatFollowers(followers: number) {
            if (followers > 999 && followers < 1000000) {
                return (followers / 1000).toFixed(1) + 'K Followers';
            } else if (followers > 999999) {
                return (followers / 1000000).toFixed(1) + 'M Followers';
            } else if (followers === 1) {
                return followers + ' Follower';
            } else {
                return followers + ' Followers';
            }
        }

        function formatLikes(likes: number) {
            if (likes > 999 && likes < 1000000) {
                return (likes / 1000).toFixed(1) + 'K Likes';
            } else if (likes > 999999) {
                return (likes / 1000000).toFixed(1) + 'M Likes';
            } else if (likes === 1) {
                return likes + ' Like';
            } else if (likes === 0) {
                return 'Like';
            } else {
                return likes + ' Likes';
            }
        }

        function formatComments(comments: any[] | undefined) {
            // console.log(comments.length)
            if (comments !== undefined) {
                console.log(comments)
                if (comments.length > 999 && comments.length < 1000000) {
                    return (comments.length / 1000).toFixed(1) + 'K Comments';
                } else if (comments.length > 999999) {
                    return (comments.length / 1000000).toFixed(1) + 'M Comments';
                } else if (comments.length === 1) {
                    return comments.length + ' Comment';
                } else if (comments.length === 0) {
                    return '0 Comments';
                } else {
                    return comments.length + ' Comments';
                }
            } else {
                return '0 Comments';
            }
        }

        return <div className="col-span-2 mx-1">
            <Toaster position="bottom-center" />
            {/* Mock profile page ... */}
        
            {/* Display Profile Feed */}
            {(() => {
                // console.log(this.state.items);
                if (this.state.loading === false && this.state.items === undefined) {
                    return <div className="bg-gray-700 w-full my-4 px-4 py-4 rounded-md">
                        <h1 className="text-lg font-bold text-center">Any purchased content will appear here!</h1>
                    </div>
                } else if (this.state.loading === false && this.state.items.length !== 0) {
                    return <FeedComponent items={this.state.items} header={true} isSelf={false} profileHeader={true} creator={this.state.user} onLoadMore={this.fetchData} hasMore={this.state.hasMore} authorizationToken={this.state.authorizationToken || undefined} />
                }
            })()}
        </div>
    }
}